import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {map, Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {ScheduledTaskStatus} from '../models/ScheduledTaskStatus';

@Injectable({
  providedIn: 'root'
})
export class SchedulerStatusService {

  url = environment.scheduledTaskStatusUrl;

  constructor(private readonly httpClient: HttpClient) {
  }

  public getAllTaskStatus(): Observable<ScheduledTaskStatus[]> {
    return this.httpClient.get<ScheduledTaskStatus[]>(this.url)
    .pipe(
      map(e => e.map(e => new ScheduledTaskStatus(e)))
    );
  }
}
